<template>
    <div class="flex flex-col gap-2">
        <UCheckbox
            v-for="o in options"
            :key="o.value"
            :model-value="current.includes(o.value)"
            :label="o.name"
            @update:model-value="toggle(o.value, $event)"
        />
    </div>
</template>

<script setup lang="ts">
import type { Filter } from '~/types/filter'

const emit = defineEmits<{ 'update:filter': [Filter] }>()
const props = defineProps<{ filter: Filter }>()

const options = [
    { name: 'Female', value: 'female' },
    { name: 'Male', value: 'male' },
]

const current = computed<string[]>(() => (Array.isArray(props.filter.value) ? props.filter.value : []))

function toggle(value: string, on: boolean) {
    const next = on ? [...current.value, value] : current.value.filter(v => v !== value)
    emit('update:filter', { ...props.filter, value: next.length ? next : undefined, selected: next.length ? next : undefined })
}
</script>
